import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const MoveInSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default MoveInSVG;
